import { Typography } from "@mui/material";
import { navigationData as NavigationData } from "../types";

export default function DirectEquityTransactionDetails(): JSX.Element {

    return (
        <Typography variant="h1" sx={{ textAlign: 'center' }}>There are no transactions done yet.</Typography>
    )
}